module.exports = __webpack_public_path__ + "img/menu-earn-yellow.71431635.svg";